export enum MyLookieroActionEvent {
  OPEN_CHECKOUT = 'navigation.click_checkout',
  PREVIEW_CLICK = 'navigation.click_preview_box_cta',
  SEND_COMMENT = 'navigation.sent_ps_comment',
  STEPPER_CLICK = 'navigation.click_info_box_status',
}
